export const Key = process.env.REACT_APP_KEY;
export const candyTechURL = process.env.REACT_APP_CANDYTECHURL

const moduleConst = process.env.REACT_APP_MODULECONST;
const moduleConstBase = process.env.REACT_APP_MODULECONSTBASE;
export const BaseURL = process.env.REACT_APP_BASEURL ;

export const BaseURLNode = process.env.REACT_APP_BASEURLNODE;
export const BaseLink = process.env.REACT_APP_BASELINK ;


export const BaseServer  = moduleConst+process.env.REACT_APP_MODULE;



export const BaseServerDashboard        = moduleConstBase+'dashboard/';
export const BaseServerNewMaster        = moduleConstBase+'newmaster/';
export const BaseServerMaster           = moduleConstBase+'master/';
export const BaseServerCloud            = moduleConstBase+'cloud/';
export const BaseServerExpense          = moduleConstBase+'expense/';
export const BaseServerInvoice          = moduleConstBase+'invoice/';
export const BaseServerClock            = moduleConstBase+'clock/';
export const BaseServerJob              = moduleConstBase+'jobcreation/';
export const BaseServerPassword         = moduleConstBase+'password-manager/';
export const BaseServerRecruitment      = moduleConstBase+'recruitment/';
export const BaseServerAccountReconcil  = moduleConstBase+'account-reconcil/';
export const BaseServerPayRoll          = moduleConstBase+'payroll/';
export const BaseServerWebsite          = moduleConstBase+'website/';
export const BaseServerParentSite       = moduleConstBase+'parentsite/';
export const BaseServerReport           = moduleConstBase+'report/';
export const BaseServerLeave            = moduleConstBase+'leave/';
export const BaseServerAdvanceInvoice   = moduleConstBase+'advanceInvoice/';
